import { Redirect } from 'react-router';

import { resetRedirectURL } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useOnMount } from 'modules/common/hooks/useOnMount';

export interface RedirectAfterLoginProps {
  to: string;
}

export const RedirectAfterLogin = ({ to }: RedirectAfterLoginProps) => {
  const dispatch = useAppDispatch();

  useOnMount(() => {
    dispatch(resetRedirectURL());
  });

  return <Redirect to={to} />;
};
